import { Component, OnInit } from '@angular/core';
import { DropDownPopupItem, TextSearchSelection } from 'quotient-ng-core';
import {
    selectAuthClaims,
    selectEnabledApplications
} from '../../../auth/store/auth.store';
import { RootState } from '../../../store/store.state';
import { select, Store } from '@ngrx/store';
import { ConfigManagerService } from '../../../shared/services/config-manager.service';
import { Router } from '@angular/router';
import { isArray, isString } from 'lodash-es';
import { Observable } from 'rxjs/Observable';
import {
    Application,
    ApplicationAccessKey
} from '../../../../../common/models/application.interface';
import { GetApplicationListRequest } from '../../../utils/store/utils.action';
import { ConfigEnvironments } from '../../../../../common/models/app-config.interface';
import {
    EventSearchCriteria,
    EventSearchType
} from '../../../../../common/models/event.interface';
import {
    EventListSearchChangeRequest,
    UpdateEventUISearchKeyword
} from '../../../events/store/events-list/event.actions';
import { EventState } from '../../../events/store/event.state';
import {
    selectEventGridUi,
    selectEventSearchCriteria
} from '../../../events/store/events-list/event.selectors';

@Component({
    selector: 'app-header-full',
    templateUrl: './header-full.component.html',
    styleUrls: ['./header-full.component.scss']
})
export class HeaderFullComponent implements OnInit {
    helpMenu: DropDownPopupItem<string | string[]>[];
    userMenu: DropDownPopupItem<string>[];
    userName: string;
    apps: Observable<Application[]>;
    showEnvironment: boolean;
    environment: ConfigEnvironments;
    app: string;

    eventGridUi: EventState['ui']['eventGrid'];
    eventSearchCriteria: EventSearchCriteria;

    searchDropdownList: DropDownPopupItem<EventSearchType>[] = [
        { value: EventSearchType.SEARCH_ALL, label: 'Search All' },
        { value: EventSearchType.EVENT, label: 'Event' },
        { value: EventSearchType.OFFER, label: 'Offer' }
    ];

    constructor(
        private router: Router,
        private store: Store<RootState>,
        private configManagerService: ConfigManagerService
    ) {
        this.environment = configManagerService.environment;
        this.showEnvironment = this.environment !== ConfigEnvironments.PROD;
        this.app = ApplicationAccessKey.MERCHANDISING;
    }

    ngOnInit() {
        this.store.pipe(select(selectAuthClaims)).subscribe(claims => {
            this.userName = claims
                ? `${claims.given_name} ${claims.family_name}`
                : '';
            this.userMenu = [
                {
                    label: claims
                        ? `${claims.given_name} ${claims.family_name}`
                        : '',
                    value: null
                },
                {
                    label: 'My Profile',
                    value: this.configManagerService.profileUrl
                },
                {
                    label: 'Sign Off',
                    value: this.configManagerService.logoutUrl
                }
            ];
        });
        this.apps = this.store.pipe(select(selectEnabledApplications));
        this.apps.subscribe((appList: Application[]) => {
            this.helpMenu = [
                // TODO: Add Help center when the merch support page is implemented.
                // { label: 'Help Center', value: ['/support/help'] }
            ];
            appList.forEach(app => {
                if (app.access_key === ApplicationAccessKey.BUSINESS) {
                    this.helpMenu.push({
                        label: 'Support/Ticket',
                        value: `${app.url}/support/tickets`
                    });
                }
            });
        });
        this.store.dispatch(new GetApplicationListRequest());
        this.store.pipe(select(selectEventGridUi)).subscribe(ui => {
            this.eventGridUi = ui;
        });
        this.store
            .pipe(select(selectEventSearchCriteria))
            .subscribe(searchCriteria => {
                this.eventSearchCriteria = searchCriteria;
            });
    }

    onItemClick(item: DropDownPopupItem<string | string[]>) {
        if (item.value && isArray(item.value)) {
            this.router.navigate(item.value);
        } else if (item.value && isString(item.value)) {
            window.location.href = item.value;
        }
    }

    handleSearchStringRequest(searchKeyword: TextSearchSelection) {
        this.store.dispatch(new UpdateEventUISearchKeyword(searchKeyword));
        this.store.dispatch(
            new EventListSearchChangeRequest({
                searchCriteria: this.eventSearchCriteria,
                pagination: {
                    pageSize: this.eventGridUi.pagination.pageSize,
                    skip: 0
                }
            })
        );
    }
}
